import path from "path";
import { lazyImport } from "../helpers/lazyImport";
import Logout from "../modules/auth/components/Logout";
import { NotFound } from "../modules/misc";
import NoAccess from "../modules/misc/routes/NoAccess";
// import { AnnotateRoutes } from '../modules/Annotate';

const { InspectionStationRoutes }: any = lazyImport(
  () => import("../modules/inspection-station"),
  "InspectionStationRoutes"
);
const { UsecaseRoutes }: any = lazyImport(
  () => import("../modules/usecase"),
  "UsecaseRoutes"
);
const { PartRoutes }: any = lazyImport(
  () => import("../modules/part"),
  "PartRoutes"
);
const { TrainingRoutes }: any = lazyImport(
  () => import("../modules/training"),
  "TrainingRoutes"
);
const { TestingRoutes }: any = lazyImport(
  () => import("../modules/testing"),
  "TestingRoutes"
);
// const { AnnotateRoutes }: any = lazyImport(() => import('../modules/Annotate'), 'AnnotateRoutes');
const { OperatorPanelRoutes }: any = lazyImport(
  () => import("../modules/operator-panel"),
  "OperatorPanelRoutes"
);
const { ReportsRoutes }: any = lazyImport(
  () => import("../modules/report"),
  "ReportsRoutes"
);
const { UserRoutes }: any = lazyImport(
  () => import("../modules/user"),
  "UserRoutes"
);
const { OperatorPanelBuilderRoutes }: any = lazyImport(
  () => import("../modules/operator-panel-builder"),
  "OperatorPanelBuilderRoutes"
);
const { RecipeBuilderRoutes }: any = lazyImport(
  () => import("../modules/recipe-builder"),
  "RecipeBuilderRoutes"
);
const { TrashRoutes }: any = lazyImport(
  () => import("../modules/trash"),
  "TrashRoutes"
);
const { VideoAnnotationroutes }: any = lazyImport(
  () => import("../modules/video-annotation"),
  "VideoAnnotationroutes"
);
const { AnnoRoutes }: any = lazyImport(
  () => import("../modules/annotate_new"),
  "AnnoRoutes"
);
const { AnalyticsV2Routes }: any = lazyImport(
  () => import("../modules/analytics-v2"),
  "AnalyticsV2Routes"
);
const { UserManagementRoutes }: any = lazyImport(
  () => import("../modules/user-management"),
  "UserManagementRoutes"
);
const { TagManagementRoutes }: any = lazyImport(
  () => import("../modules/tag-management"),
  "TagManagementRoutes"
);
const { AIInspectorRoutes }: any = lazyImport(
  () => import("../modules/ai-inspector"),
  "AIInspectorRoutes"
);
const { AuditLogRoutes }: any = lazyImport(
  () => import("../modules/audit-log"),
  "AuditLogRoutes"
);
const { OngoingTrainingRoutes }: any = lazyImport(
  () => import("../modules/ongoing-training"),
  "OngoingTrainingRoutes"
);
const { DashboardRoutes }: any = lazyImport(
  () => import("../modules/dashboard"),
  "DashboardRoutes"
);

const { ClassBasedAugmentationRoutes }: any = lazyImport(
  () => import("../modules/class-based-augmentation"),
  "ClassBasedAugmentationRoutes"
);

const { DefectLibraryRoutes }: any = lazyImport(
  () => import("../modules/defect-dataset-library"),
  "DefectLibraryRoutes"
);

const { SyntheticDatasetRoutes }: any = lazyImport(
  () => import("../modules/synthetic-data"),
  "SyntheticDatasetRoutes"
);

const { ImproveRoutes }: any = lazyImport(
  () => import("../modules/improve"),
  "ImproveRoutes"
);

const { TermsRoutes }: any = lazyImport(
  () => import("../modules/terms-and-condition"),
  "TermsRoutes"
);

const { NotificationRoutes }: any = lazyImport(
  () => import("../modules/notifications"),
  "NotificationRoutes"
);

const { AllNotificationRoutes }: any = lazyImport(
  () => import("../modules/all-notifications"),
  "AllNotificationRoutes"
);

const { InspectionReportsRoutes }: any = lazyImport(
  () => import("../modules/inspection-reports"),
  "InspectionReportsRoutes"
);

const { HelpCenterRoutes }: any = lazyImport(
  () => import("../modules/help"),
  "HelpCenterRoutes"
);

const { AnnotationRoutes }: any = lazyImport(
  () => import("../modules/annotation"),
  "AnnotationRoutes"
);

const { SupervisorDashboardRoutes }: any = lazyImport(
  () => import("../modules/supervisor-dashboard"),
  "SupervisorDashboardRoutes"
);

const { SubscriptionRoutes }: any = lazyImport(
  () => import("../modules/subscription"),
  "SubscriptionRoutes"
)
const { AddonRequestsRoutes }: any = lazyImport(
  () => import("../modules/subscription"),
  "AddonRequestsRoutes"
)

const { ClientUserManagementRoutes }: any = lazyImport(
  () => import("../modules/client-user-management"),
  "ClientUserManagementRoutes"
);

const { ReportsAnalyticsRoutes }: any = lazyImport(
  () => import("../modules/reports-analytics"),
  "ReportsAnalyticsRoutes"
);
const { SyntheticDataGeneratorRoutes }: any = lazyImport(
  () => import("../modules/synthetic-data-generator"),
  "SyntheticDataGeneratorRoutes"
);

const { ArchiveSettingsRoutes }: any = lazyImport(
  () => import("../modules/archive-settings"),
  "ArchiveSettingsRoutes"
);

const { StorageConfigurationRoutes }: any = lazyImport(
  () => import("../modules/storage-configuration"),
  "StorageConfigurationRoutes"
);

const { AddonPaymentRoutes }: any = lazyImport(
  () => import("../modules/addon-payments"),
  "AddonPaymentRoutes"
);

const { ClassLibraryRoutes }: any = lazyImport(
  () => import("../modules/class-library"),
  "ClassLibraryRoutes"
);

const { ColorDetectionRoutes }: any = lazyImport(
  () => import("../modules/color-detection"),
  "ColorDetectionRoutes"
);

const { SyntheticRoutes }: any = lazyImport(
  () => import("../modules/synthetic-dataset-generator"),
  "SyntheticRoutes"
);

const { TrainingMainRoutes }: any = lazyImport(
  () => import("../modules/training-new"),
  "TrainingMainRoutes"
);

const { AIAssistantKnowledgeBaseRoutes }: any = lazyImport(
  () => import("../modules/ai-assistant-knowledge-base"),
  "AIAssistantKnowledgeBaseRoutes"
)
const { LicenseManagementRoutes }: any = lazyImport(
  () => import("../modules/license-management"),
  "LicenseManagementRoutes"
)
const { PlanLicenseUsageRoutes }: any = lazyImport(
  () => import("../modules/plan-license-usage"),
  "PlanLicenseUsageRoutes"
)
const { PlanManagementRoutes }: any = lazyImport(
  () => import("../modules/plan-management"),
  "PlanManagementRoutes"
)



export const protectedRoutes = [
  {
    path: "/app/inspection/*",
    element: <InspectionStationRoutes />,
  },
  {
    path: "/app/usecase/*",
    element: <UsecaseRoutes />,
  },
  {
    path: "/app/part/*",
    element: <PartRoutes />,
  },
  {
    path: "/app/training/*",
    element: <TrainingRoutes />,
  },
  {
    path: "/app/testing/*",
    element: <TestingRoutes />,
  },
  {
    path: "/app/analytics/*",
    element: <AnalyticsV2Routes />,
  },
  // {
  //   path: '/app/annotate_old/*',
  //   element: <AnnotateRoutes />,
  // },
  {
    path: "/app/annotate/*",
    element: <AnnoRoutes />,
  },
  {
    path: "/app/dashboard/*",
    element: <DashboardRoutes />,
  },
  {
    path: "/app/operator/*",
    element: <OperatorPanelRoutes />,
  },
  {
    path: "/app/old/reports/*",
    element: <ReportsRoutes />,
  },
  {
    path: "/app/reports/*",
    element: <InspectionReportsRoutes />,
  },
  {
    path: "/app/builder/*",
    element: <OperatorPanelBuilderRoutes />,
  },
  {
    path: "/app/deployment/*",
    element: <RecipeBuilderRoutes />,
  },
  {
    path: "/app/logout/",
    element: <Logout />,
  },
  {
    path: "/app/user/*",
    element: <UserRoutes />,
  },
  {
    path: "/app/manage/*",
    element: <UserManagementRoutes />,
  },
  {
    path: "/app/tag-management/*",
    element: <TagManagementRoutes />,
  },
  {
    path: "/app/trash/*",
    element: <TrashRoutes />,
  },
  {
    path: "/app/video-annotation/*",
    element: <VideoAnnotationroutes />,
  },
  {
    path: "/app/inspector/*",
    element: <AIInspectorRoutes />,
  },
  {
    path: "/app/logs/*",
    element: <AuditLogRoutes />,
  },
  {
    path: "app/ongoing-training/*",
    element: <OngoingTrainingRoutes />,
  },
  {
    path: "/app/no-access/*",
    element: <NoAccess />,
  },
  {
    path: "/app/class-based-augmentation/*",
    element: <ClassBasedAugmentationRoutes />,
  },
  {
    path: "/app/defect-library/*",
    element: <DefectLibraryRoutes />,
  },
  {
    path: "/app/synthetic-data/*",
    element: <SyntheticDatasetRoutes />,
  },
  {
    path: "/app/improve/*",
    element: <ImproveRoutes />,
  },
  {
    path: "/app/terms-and-conditions/*",
    element: <TermsRoutes />,
  },
  {
    path: "/app/plan-license-usage/*",
    element: <PlanLicenseUsageRoutes />,
  },
  {
    path: "/app/plan-management/*",
    element: <PlanManagementRoutes />,
  },
  {
    path: "/app/annotation/*",
    element: <AnnotationRoutes />,
  },
  {
    path: "/app/supervisor/*",
    element: <SupervisorDashboardRoutes />,
  },
  {
    path: "/app/help-center/*",
    element: <HelpCenterRoutes />,
  },
  {
    path: "/app/subscription/*",
    element: <SubscriptionRoutes />,
  },
  {
    path: "/app/addon-requests/*",
    element: <AddonRequestsRoutes />,
  },
  {
    path: "/app/client/user/*",
    element: <ClientUserManagementRoutes />,
  },
  {
    path: "/app/reports-analytics/*",
    element: <ReportsAnalyticsRoutes />,
  },
  {
    path: "/app/generate/synthetic-data/*",
    element: <SyntheticDataGeneratorRoutes />,
  },
  {
    path: "/app/archive-settings/*",
    element: <ArchiveSettingsRoutes />,
  },
  {
    path: "/app/all-notifications/*",
    element: <AllNotificationRoutes />,
  },
  {
    path: "/app/notifications/*",
    element: <NotificationRoutes />,
  },
  {
    path: "/app/storage-configuration/*",
    element: <StorageConfigurationRoutes />,
  },
  {
    path: "/app/payments/*",
    element: <AddonPaymentRoutes />,
  },
  {
    path: "/app/class-library/*",
    element: <ClassLibraryRoutes />,
  },
  {
    path: "/app/color-detection/*",
    element: <ColorDetectionRoutes />,
  },
  {
    path: "/app/synthetic-dataset-generator/*",
    element: <SyntheticRoutes />,
  },
  {
    path: "/app/training-new/*",
    element: <TrainingMainRoutes />,
  },
  {
    path: "/app/ai-assistant-knowledge-base/*",
    element: <AIAssistantKnowledgeBaseRoutes />,
  },
  {
    path: "/app/license-management/*",
    element: <LicenseManagementRoutes />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
